import { ConsoleFormattedStream } from '@browser-bunyan/console-formatted-stream';
import { INFO, createLogger, stdSerializers, } from 'browser-bunyan';
export function createClientLoggerFactory(name, streams = [
    {
        level: INFO,
        stream: new ConsoleFormattedStream(),
    },
], serializers = stdSerializers, src = false) {
    return createLogger({
        name,
        streams,
        serializers,
        src,
    });
}
